import PropTypes from 'prop-types'
import { useCallback, useMemo } from 'react'
import MfSelect from './MfSelect'

export const MfActionSelect = props => {
  const handleChange = useCallback(
    selectedOpt => {
      if (props.onOptionChange) {
        props.onOptionChange(selectedOpt)
      }
      if (selectedOpt.manualUpdate) return
      selectedOpt.onPress()
    },
    [props.onOptionChange]
  )

  const customStyles = useMemo(
    () => ({
      placeholder: () => ({
        fontWeight: 'bold',
        color: 'white'
      }),
      control: () => ({
        backgroundColor: props.color,
        boxSizing: 'content-box',
        border: 'none',
        paddingTop: 1,
        paddingBottom: 1,
        paddingLeft: 8
      }),
      valueContainer: () => ({
        fontWeight: 'bold',
        paddingRight: 0
      }),
      singleValue: () => ({
        color: 'white'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),
      dropdownIndicator: () => ({
        color: 'white',
        '&:hover': {
          color: 'white'
        }
      })
    }),
    []
  )

  return (
    <MfSelect
      {...props}
      isSearchable={false}
      customStyles={customStyles}
      onChange={handleChange}
      isDisabled={props.disabled}
      options={props.actions}
      defaultValue={props.selectedOption}
    />
  )
}

MfActionSelect.defaultProps = {
  color: '#00A0DD',
  selectedOption: null,
  actions: [
    { value: 'mf_action_1', label: 'MfAction 1', onPress: () => {} },
    { value: 'mf_action_2', label: 'MfAction 2', onPress: () => {} }
  ],
  placeholder: '',
  disabled: false,
  onOptionChange: null
}

MfActionSelect.propTypes = {
  color: PropTypes.string,
  selectedOption: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
    label: PropTypes.string.isRequired,
    onPress: PropTypes.func.isRequired,
    manualUpdate: PropTypes.bool
  }),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
      label: PropTypes.string.isRequired,
      onPress: PropTypes.func.isRequired
    })
  ).isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onOptionChange: PropTypes.func
}

export default MfActionSelect
